export default __webpack_public_path__ + "static/media/4.df8ec3a6.svg";